/**
 * Development environment configuration
 */
export const environment = {
  env: 'dev',
  // Logging configuration
  logging: {
    level: 'DEBUG',
    enableConsole: true,
  },
  firebase: {
    apiKey: "AIzaSyBlAHaW-E_2f7qePc7t8I7qbRPRbUiOoe0",
    authDomain: "mevolve-dev.firebaseapp.com",
    databaseURL: "https://mevolve-dev-default-rtdb.europe-west1.firebasedatabase.app",
    supportDatabaseURL: "https://mevolve-dev-support.europe-west1.firebasedatabase.app",
    projectId: "mevolve-dev",
    storageBucket: "mevolve-user-files-dev",
    messagingSenderId: "825137847857",
    appId: "1:825137847857:web:4765ff49ccd1a83aff3f10",
    measurementId: "G-WNRV7L023K",
  },
  recaptchaSiteKey: "6LfSN3UpAAAAABQT6UPUwzfVwGgVrVNucrfV5b8-",
  // Local functions emulator (disabled by default, use npm run start:local)
  useLocalFunctions: false,
  localFunctionsHost: 'localhost',
  localFunctionsPort: 5001,
};
